import React, { FunctionComponent } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { ACard } from "@atiautomacao/ati-ui-library";
import themeDefaults from "../../../Shared/Theme/ThemeDefaults";

type Item = { label: string; count?: number };

const defaultGetAlarmText = (count?: number) => {
    if (!count || count === 0) {
        return <Typography variant="body2" style={{ color: themeDefaults.colors.mediumGreen }}>Sem alarmes</Typography>;
    }
    return <Typography variant="body2" style={{ color: themeDefaults.colors.orangeEnergy }}>{`${count} ${count > 1 ? 'Alarmes ativos' : 'Alarme ativo'}`}</Typography>;
}

const TotalizerCard: FunctionComponent<{
    title: string;
    iconBox?: React.ReactNode;
    items: Item[];
    renderCount?: (count?: number) => React.ReactNode;
}> = ({ title, iconBox, items, renderCount = defaultGetAlarmText }) => {
    return (
        <ACard
            styleProps={{
                cardStyle: { padding: '0 16px', height: window.innerWidth < 800 ? '150px' : '140px', borderRadius: '8px' },
                titleStyle: { display: 'none' },
                headerStyle: { display: 'flex', flexDirection: 'column', padding: '0 16px', marginTop: '-16px' },
                headerActionsStyle: { display: 'flex' },
                contentStyle: { padding: '0px' }
            }}
            headerControls={<div style={{ fontSize: '18px', justifyContent: 'flex-start', display: 'flex', alignItems: 'center' }}>
                {iconBox}
                <Typography variant="h6" style={{marginLeft: -8}}>{title}</Typography>
            </div>}
        >
            <>
                <Divider orientation="horizontal" flexItem sx={{ paddingLeft: 16 }} />
                <Grid container paddingTop={'8px'}>
                    <Grid item style={{ display: 'flex', justifyContent: 'left', alignItems: 'center'}} xs={7}>
                        <Box>
                            {items.map((it, idx) => (
                                <Typography variant="body2" key={idx}>{it.label}</Typography>
                            ))}
                        </Box>
                    </Grid>

                    <Grid item style={{ display: 'flex', justifyContent: 'right', alignItems: 'center'}} xs={5}>
                        <Box>
                            {items.map((it, idx) => (
                                <Typography variant="body2" style={{ textAlign: 'right' }} key={idx}>
                                    {renderCount(it.count)}
                                </Typography>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </>
        </ACard>
    );
};

export default TotalizerCard;